export default () => ({
  inputLabel: {
    width: 50,
  },
  input: {
    width: 50,
  },
  icon: {
    opacity: 0.3,
    width: 30,
    color: '#A6A6A6',
  },
  absentLockSpacing: {
    width: 30,
  },
  positionLock: {
    display: 'inline-block',
  },
  sectionRow: {
    display: 'flex',
    alignItems: 'center',
  },
  formLabel: {
    width: 60,
    color: 'rgba(0,0,0,1)',
  },
});
